<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" :right="topBarRight" :is-right-select="isTopBarRightSelect" @leftClick="onBack" @rightClick="onBookmark" />
    <van-skeleton title :row="15" :loading="loadingPage">
      <div id="pageRect" class="pageRect">
        <iframe id="baseRect" class="baseRect" :src="programUrl" />
      </div>
    </van-skeleton>
    <div class="buttons">
      <van-row>
        <van-col span="6" :class="showMenu?'mainColor':''"><i class="iconfont iconmulu" @click="onShowMenu" /></van-col>
        <van-col span="6" :class="upPage?'mainColor':''"><i class="iconfont iconshangyiye" @click="onUpPage" /></van-col>
        <van-col span="6" :class="downPage?'mainColor':''"><i class="iconfont iconxiayiye" @click="onDownPage" /></van-col>
        <van-col span="6" :class="showMore?'mainColor':''"><i class="iconfont icongengduo" @click="onShowMore" /></van-col>
      </van-row>

    </div>

    <van-popup v-model="showNote" class="noteMore" position="bottom" :overlay="false" :close-on-click-overlay="false">
      <textarea v-model="noteBody" class="NoteBody" rows="8" :maxlength="2048" placeholder="请在这里填写学习笔记......" />
      <van-button type="info" square :loading="loadingNote" @click="onEditNote">保存</van-button>
    </van-popup>
    <van-popup v-if="data && data.courseInfo" v-model="showAbout" class="aboutMore" position="bottom" :overlay="false" :close-on-click-overlay="false">
      <div class="title">{{ data.courseInfo.program }}</div>
      <img :src="data.courseInfo.image">
      <div class="body">{{ data.courseInfo.description }}</div>
    </van-popup>
    <van-popup v-model="showMore" class="menuMore" position="bottom" :overlay="false" :close-on-click-overlay="false">
      <van-row>
        <template v-if="userAccessLevel>=50">
          <van-col span="8"><span @click="onOpenNote"><i class="iconfont iconkechengbaoming" />笔记</span></van-col>
          <van-col span="8"><span @click="onOpenAbout"><i class="iconfont iconguanyukecheng" />关于课程</span></van-col>
          <van-col span="8"><span @click="onChangeReader"><i class="iconfont iconwode" />{{ isCoachPage?'教练模式':'学员模式' }}</span></van-col>
        </template>
        <template v-if="userAccessLevel<50">
          <van-col span="12"><span @click="onOpenNote"><i class="iconfont iconkechengbaoming" />笔记</span></van-col>
          <van-col span="12"><span @click="onOpenAbout"><i class="iconfont iconguanyukecheng" />关于课程</span></van-col>
        </template>
      </van-row>
    </van-popup>
    <van-popup v-model="showMenu" class="menuRect" position="bottom" :overlay="false">

      <div class="menuButton">
        <van-row>
          <van-col span="6"><span :class="menuType=='menu'?'select':''" @click="onMenuType('menu')">目录</span></van-col>
          <van-col span="6"><span :class="menuType=='unread'?'select':''" @click="onMenuType('unread')">未读</span></van-col>
          <van-col span="6"><span :class="menuType=='bookmark'?'select':''" @click="onMenuType('bookmark')">书签</span></van-col>
          <van-col span="6"><span :class="menuType=='note'?'select':''" @click="onMenuType('note')">笔记</span></van-col>
        </van-row>
      </div>
      <div v-if="menuType=='menu' || menuType=='unread'" class="menuBody">
        <!-- {{ homeLine.title }} -->
        <template v-for="item1 in menu">
          <div v-if="item1.pid === homeLine.uid &&item1.access_level<=userAccessLevel &&((!isCoachPage && item1.access_level<50) ||(isCoachPage && item1.access_level>=50))" :key="item1.uid" class="title1">
            <div>{{ item1.title }}</div>
            <template v-for="item2 in menu">
              <div v-if="item2.pid === item1.uid &&item2.access_level<=userAccessLevel &&((!isCoachPage && item2.access_level<50) ||(isCoachPage && item2.access_level>=50))" :key="item2.uid" :class="item2.isRead?'title2read':'title2'">
                <span @click="onMenuLine(item2.uid)">{{ item2.title }}</span>
                <template v-for="item3 in menu">
                  <div v-if="item3.pid === item2.uid &&item3.access_level<=userAccessLevel &&((!isCoachPage && item3.access_level<50) ||(isCoachPage && item3.access_level>=50))" :key="item3.uid" :class="item3.isRead?'title3read':'title3'" @click="onMenuLine(item3.uid)">
                    {{ item3.title }}
                  </div>
                </template>
              </div>
            </template>
          </div>
        </template>
      </div>
      <div v-if="menuType=='bookmark' || menuType=='note'" class="menuBody">
        <template v-for="item2 in menu">
          <div v-if="item2.access_level<=userAccessLevel" :key="item2.uid" class="title2" @click="onMenuLine(item2.uid)">
            {{ item2.title }}
          </div>
        </template>
      </div>
    </van-popup>
  </div>
</template>
<script>
import request from '@/utils/request'
// import axios from 'axios'
import TopBar from '@/components/TopBar'
import { initPage, getUrlKey, MyNotify } from '@/utils/base'
import { Button, Popup, Skeleton, Dialog, Toast } from 'vant'
export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Skeleton.name]: Skeleton,
    [Dialog.name]: Dialog,
    [Toast.name]: Toast,
    TopBar
  },
  data() {
    return {
      id: undefined,
      courseId: undefined,
      title: '课程学习',
      backurl: '/home/index',
      data: undefined,
      baseUrl: undefined,
      menuType: 'menu',
      loadingPage: true,
      tryLoginAgain: true,
      upPage: false,
      downPage: false,
      showMenu: false,
      showMore: false,
      showNote: false,
      showAbout: false,
      menu: undefined,
      menuData: undefined,
      homeLine: undefined,
      programUrl: undefined,
      topBarRight: 'iconbookmark',
      isTopBarRightSelect: false,
      loadingEditBookmark: false,
      loadingNote: false,
      userAccessLevel: 0,
      nowPageId: undefined,
      noteBody: undefined,
      timeAutoRead: undefined,
      isCoachPage: false
    }
  },
  // beforeRouteLeave(to, from, next) {
  //   Toast.clear()
  // },
  mounted() {
    var my = this
    window.addEventListener('message', function(e) {
      console.log('监听到了Message', e.data)
      if (!e.data) {
        return
      }
      if(e.data.type==='EXAM_FINISH')
      {
        console.log('监听到了Message EXAM_FINISH')
        my.init(false);
        return;
      }


      var dataStr = e.data.toString()
      if (dataStr.indexOf('[') !== 0) {
        return
      }
      if (dataStr.indexOf(']') <= 0) {
        return
      }
      if (dataStr.indexOf(',') <= 0) {
        return
      }
      request({
        url: '/user/setTestResult',
        method: 'post',
        data: {
          body: dataStr,
          courseId: my.data.courseId,
          programId: my.id,
          testPage: parseInt(my.nowPageId)
        }
      }).then(response => {
        console.log('网络请求后反馈', response)
        if (response.success) {
          // my.data.testPassList.push(response.data)
        }
      })
    }, false)
  },
  created() {
    initPage(true)
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
    this.id = this.$route.params.id
    this.courseId = getUrlKey('cid')
    this.tryLoginAgain = true
    this.init(true)
    Toast.loading({
      mask: true,
      duration: 0,
      message: '正在与SSI同步您的学习进度请等待...'
    })
  },
  methods: {
    init(isFirst) {
      this.isCoachPage = false
      request({
        url: '/user/getProgram',
        method: 'post',
        params: {
          programId: this.id,
          courseId: this.courseId
        }
      }).then(response => {
        if (!response.success) {
          return
        }
        console.log(response)
        this.data = response.data
        this.userAccessLevel = this.data.userAccessLevel
        // 如果资源包尚未准备好
        var my = this
        if (!this.data.programIsReady) {
          var message = '尚有' + this.data.needDownloadFileNum + '个\n文件在缓存\n请耐心等待\n或稍后访问'
          var duration = 20000
          if (this.data.needDownloadFileNum <= 0) {
            message = '正在检查更新\n请耐心等待'
            duration = 2000
          }
          Toast.loading({
            duration: duration,
            message: message,
            onClose: function() {
              if (my.tryLoginAgain) {
                my.init()
              }
            }
          })
          return
        } else {
          this.tryLoginAgain = false
        }
        this.baseUrl = this.data.baseUrl
        // this.programUrl = this.baseUrl + 'index.html'
        // this.baseUrl = 'https://localhost:44341/programs/20075991_1560926184_ENG/'
        console.log("this.getMenu")
        if(isFirst){
          console.log("首次进入")
          this.getMenu(this.data.pageList, () => {
            setTimeout(() => {
              console.log("this.getMenu callback")
              this.initReader(this.data.userid,this.data.finalExamsData)
            }, 1)
            my.menu.some((value, index, array) => {
              value.isRead = my.data.visitIds.find((ids, index, array) => ids === value.uid) !== undefined
              value.isBookmark = my.data.bookMarksList.find((item, index, array) => item.cid.toString() === value.uid) !== undefined
              value.isNote = my.data.noteList.find((item, index, array) => item.pid.toString() === value.uid) !== undefined
            })
            this.onMenuLine(this.nowPageId)
          })
          if (this.data.lastPageId && this.data.lastPageId.length > 0) {
            Dialog.confirm({
              title: '阅读记录',
              message: '是否前往到最后阅读的位置继续阅读?',
              cancelButtonText: '取消',
              confirmButtonText: '前往'
            }).then(() => {
              this.onMenuLine(this.data.lastPageId)
            })
          }
        }else{
          console.log("非首次进入")
          this.initReader(this.data.userid,this.data.finalExamsData)
        }
      })
    },
    onBack() {
      this.tryLoginAgain = false
      Toast.clear()
      if (this.timeAutoRead) {
        window.clearTimeout(this.timeAutoRead)
        this.timeAutoRead = undefined
      }
    },
    onBookmark() {
      if (this.loadingPage) {
        MyNotify('info', '尚未加载完成,请稍后...')
        return
      }
      if (this.loadingEditBookmark) {
        return
      }
      this.loadingEditBookmark = true
      var my = this
      var nowID = this.nowPageId
      if (this.isTopBarRightSelect) {
        var line = this.data.bookMarksList.filter((item, index) => item.cid.toString() === this.nowPageId)
        var bookMarkId
        console.log(line)
        if (line && line.length > 0) {
          bookMarkId = line[0].id
        } else {
          return
        }
        request({
          url: '/user/removeBookmark',
          method: 'post',
          data: { courseId: this.data.courseId, pageId: bookMarkId }
        }).then(response => {
          my.loadingEditBookmark = false
          if (!response.success) {
            return
          }
          MyNotify('success', '书签移除成功')
          my.menuData.map((value, index, array) => {
            if (value.uid === nowID) {
              value.isBookmark = false
              my.reloadMenuList()
            }
          })
        })
      } else {
        request({
          url: '/user/addBookmark',
          method: 'post',
          data: { courseId: this.data.courseId, pageId: nowID }
        }).then(response => {
          my.loadingEditBookmark = false
          if (!response.success) {
            return
          }
          if (!response.data) {
            return
          }
          this.data.bookMarksList.push(response.data)
          MyNotify('success', '添加书签成功')
          my.menuData.map((value, index, array) => {
            if (value.uid === nowID) {
              value.isBookmark = true
              my.reloadMenuList()
            }
          })
        })
      }
      this.isTopBarRightSelect = !this.isTopBarRightSelect
    },
    onShowMenu() {
      if (this.loadingPage) {
        MyNotify('info', '尚未加载完成,请稍后...')
        return
      }
      this.showMenu = !this.showMenu
      this.showMore = false
      this.showNote = false
      this.showAbout = false
    },
    onShowMore() {
      this.showMenu = false
      this.showMore = !this.showMore
      this.showNote = false
      this.showAbout = false
    },
    onOpenNote() {
      if (this.loadingPage) {
        MyNotify('info', '尚未加载完成,请稍后...')
        return
      }
      this.showMenu = false
      this.showMore = false
      this.showAbout = false
      this.showNote = true
    },
    onOpenAbout() {
      this.showMenu = false
      this.showMore = false
      this.showNote = false
      this.showAbout = true
    },
    onMenuType(typeName) {
      this.menuType = typeName
      this.reloadMenuList()
    },
    reloadMenuList() {
      switch (this.menuType) {
        case 'menu':
          this.menu = this.menuData
          break
        case 'unread':
          this.menu = this.menuData.filter((item, index) => item.isRead === false)
          break
        case 'bookmark':
          this.menu = this.menuData.filter((item, index) => item.isBookmark === true)
          break
        case 'note':
          this.menu = this.menuData.filter((item, index) => item.isNote === true)
          break
      }
      //
    },
    findParentAccessLevel(list, upId, userAccessLevel) {
      var findItem = list.find(item => item.uid === upId)
      if (findItem && findItem.access_level > userAccessLevel) {
        return false
      }
      return true
    },
    onUpPage() {
      if (this.loadingPage) {
        MyNotify('info', '尚未加载完成,请稍后...')
        return
      }
      if (!this.menuData) {
        return
      }
      var my = this
      if (my.upPage) {
        return
      }
      this.showMenu = false
      this.showMore = false
      this.showNote = false
      this.showAbout = false
      my.upPage = true
      setTimeout(() => {
        my.upPage = false
      }, 300)
      var findId = false
      var nextValue
      my.menuData.reverse().some((value, index, array) => {
        if (value.access_level <= my.userAccessLevel && value.level >= 1 && my.findParentAccessLevel(my.menuData, value.pid, my.userAccessLevel) &&
          (!value.pagetype || value.pagetype === 1) &&
          ((!this.isCoachPage && value.access_level < 50) || (this.isCoachPage && value.access_level >= 50))) {
          if (findId) {
            nextValue = value
            return true
          }
          if (value.uid === my.nowPageId) {
            findId = true
          }
        }
      })
      my.menuData.reverse()
      if (!nextValue) {
        MyNotify('error', '已经是第一页了!')
        return
      }
      this.onMenuLine(nextValue.uid)
      console.log('上一页是:', nextValue)
    },
    onDownPage() {
      if (this.loadingPage) {
        MyNotify('info', '尚未加载完成,请稍后...')
        return
      }
      if (!this.menuData) {
        return
      }
      var my = this
      if (my.downPage) {
        return
      }
      this.showMenu = false
      this.showMore = false
      this.showNote = false
      this.showAbout = false
      this.downPage = true
      setTimeout(() => {
        my.downPage = false
      }, 300)
      var findId = false
      var nextValue
      my.menuData.some((value, index, array) => {
        if (value.access_level <= my.userAccessLevel && value.level >= 1 && my.findParentAccessLevel(my.menuData, value.pid, my.userAccessLevel) &&
         (!value.pagetype || value.pagetype === 1) &&
         ((!this.isCoachPage && value.access_level < 50) || (this.isCoachPage && value.access_level >= 50))) {
          if (findId) {
            nextValue = value
            return true
          }
          if (value.uid === my.nowPageId) {
            findId = true
          }
        }
      })
      if (!nextValue) {
        MyNotify('error', '已经是最后一页了!')
        return
      }
      this.onMenuLine(nextValue.uid)
      console.log('下一页是:', nextValue)
    },
    getMenu(data, callback) {
      var my = this

      my.loadingPage = false
      Toast.clear()
      console.log('目录1', data)
      my.menuData = data
      my.homeLine = my.menuData.filter(m => m.pid === null)[0]
      my.title = my.homeLine.title
      my.onMenuLine(my.homeLine.uid)
      // console.log('第一页', my.menuData[1])
      // my.menuData.some((value, index, array) => {
      //   if (value.access_level <= my.userAccessLevel && value.level === 2 && (!value.pagetype || value.pagetype === 1)) {
      //     my.nowPageId = value.uid
      //     return true
      //   }
      // })
      my.reloadMenuList()
      console.log("getMenu callback",callback)
      if (callback) {
        callback()
      }
    },
    showTestResult(uid) {
      // 判断是否是测试页面,是的话展示测试成绩
      var pageData = this.menuData.find((item, index, array) => item.uid === uid)
      if (pageData && pageData.isReviewPage) {
        console.log('pageData', pageData)
        if (this.data.testPassList) {
          var testInfo = this.data.testPassList.find((item, index, array) => item.testpage.toString() === uid)
          console.log('testInfo', testInfo)
          if (testInfo) {
            if (testInfo.passed === 1) {
              MyNotify('success', '当前测验已通过(' + testInfo.percent + '%)', 5000)
            } else {
              MyNotify('info', '当前测验未通过(' + testInfo.percent + '%)', 5000)
            }
            return
          }
        }
        MyNotify('info', '尚未完成该测验', 2000)
      }
    },
    onMenuLine(uid) {
      console.log('打开页码' + uid)
      this.menuData.map((value, index, array) => {
        if (value.pid === uid) {
          console.log('我还有子集' + uid)
          uid = value.uid
        }
      })
      console.log('menuData', this.menuData)
      var pageObj = this.menuData.filter(m => m.uid === uid)
      if (pageObj.length <= 0) {
        return
      }
      pageObj = pageObj[0]

      this.nowPageId = uid
      this.showMenu = false
      this.programUrl = this.baseUrl + pageObj.uri
      console.log('读取的文档:', this.programUrl)
      this.loadNote(uid)
      this.showTestResult(uid)
      // 标记已读 5秒自动标记
      const my = this
      if (this.timeAutoRead) {
        window.clearTimeout(this.timeAutoRead)
        this.timeAutoRead = undefined
      }
      var pageData = this.menuData.find((item, index, array) => item.uid === uid)
      if (pageData) {
        this.isTopBarRightSelect = pageData.isBookmark
        console.log('标记已读', pageData)
        this.timeAutoRead = window.setTimeout(() => {
          request({
            url: '/user/readProgramPage',
            method: 'post',
            data: { courseId: this.data.courseId, pageId: uid }
          }).then(response => {
            if (!response.success) {
              return
            }
            if (response.data) {
              my.menuData.map((value, index, array) => {
                if (value.uid === uid) {
                  value.isRead = true
                  my.reloadMenuList()
                  console.log('标记完成', pageData.uid)
                }
              })
            }
          })
        }, pageData.isRead ? 1000 * 600 : 5000)
      }
    },
    loadNote(uid) {
      if (!this.data.noteList) {
        this.noteBody = undefined
        return
      }
      // 读取笔记
      var notes = this.data.noteList.find((item, index, array) => item.pid.toString() === uid)
      if (notes) {
        this.noteBody = notes.notetext
      } else {
        this.noteBody = undefined
      }
    },
    onEditNote() {
      this.loadingNote = true
      var line = this.data.noteList.filter((item, index) => item.pid.toString() === this.nowPageId)
      var noteId
      console.log(line)
      if (line && line.length > 0) {
        noteId = line[0].id
      }
      if (this.noteBody === '') {
        this.noteBody = undefined
      }
      request({
        url: '/user/setNote',
        method: 'post',
        data: { noteId: noteId, courseId: this.data.courseId, pageId: this.nowPageId, noteBody: this.noteBody }
      }).then(response => {
        this.loadingNote = false
        if (!response.success) {
          return
        }
        var my = this
        if (this.noteBody === undefined) {
          this.data.noteList = this.data.noteList.filter((item, index) => item.pid.toString() !== this.nowPageId)
          this.menuData.map((value, index, array) => {
            if (value.uid.toString() === this.nowPageId) {
              value.isNote = false
              my.reloadMenuList()
            }
          })
        } else if (!noteId) {
          this.data.noteList.push(response.data)
          this.menuData.map((value, index, array) => {
            if (value.uid.toString() === this.nowPageId) {
              value.isNote = true
              my.reloadMenuList()
            }
          })
        }
        MyNotify('success', '保存笔记成功')
      })
    },
    onChangeReader() {
      this.menu = JSON.parse(JSON.stringify(this.menu))
      // MyNotify('success', '执行测试')
      this.isCoachPage = !this.isCoachPage
      var iframe = window.document.getElementById('baseRect')
      // console.log("iframe",iframe)
      iframe.contentWindow.postMessage(this.isCoachPage, '*')
      // MyNotify('success', '执行测试完成:'+ this.isCoachPage?'教练页面':'学员页面')
    },
    initReader(userid,finalExamsData) {
      console.log("initReader userid",userid)
      console.log("initReader",finalExamsData)
      var iframe = window.document.getElementById('baseRect')
      console.log("iframe",iframe)
      var my = this
      if (iframe.attachEvent) { // 兼容IE写法
        iframe.attachEvent('onload', function() {
          console.log("testInit onload",my.isCoachPage)
          // iframe加载完成后要进行的操作
          if (my.isCoachPage) {
            iframe.contentWindow.postMessage(my.isCoachPage, '*')
          }
        })
      } else {
        iframe.onload = function() {
          console.log("testInit onload1",my.isCoachPage)
          // iframe加载完成后要进行的操作
          if (my.isCoachPage) {
            iframe.contentWindow.postMessage(my.isCoachPage, '*')
          }
          if(finalExamsData.length>0){
            setTimeout(() => {
              try {
                iframe.contentWindow.postMessage({
                  type: 'INIT_EXAM',
                  passed: finalExamsData[0].passed,
                  attemptsExceeded: finalExamsData[0].attemptsExceeded, 
                  attempts: finalExamsData[0].attempts,
                  userid: userid,
                  courseId:my.data.courseId,
                  pid:my.nowPageId
                }, 'https://res.myssi.cn');
                window.document.getElementById('baseRect').contentWindow.postMessage({type: 'ImSmFalse'}, 'https://res.myssi.cn');
              } catch (error) {
                console.error('doError:', error);
              }
            }, 1000);
          }
         
        }
      }
    }
  }
}

</script>
<style scoped>
.pageRect{
    position:fixed;
    left: -14px;
    right: 0;
    top: 3em;
    bottom: 3em;
 -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
}
.baseRect{
    width: calc(100% - 14px);
    height: 100%;
    border: none;
    padding-left: 1em;
}
.buttons{
  position: fixed;
  text-align: center;
  left: 0;
  width: 100%;
  bottom: 0em;
  line-height: 3em;

  height: 3em;
  background-color: #000;
  color: #fff;
  z-index: 3000;
}
.buttons i{
  font-size: 0.8em;
}
.menuRect{
  position: absolute;
  left: 0px;
  top:3em;
  bottom:3em;
  width: 70%;
  background-color: #191919;
  line-height: 2.5em;
}
.menuButton{
  position:fixed;
  height: 3em;
  line-height: 3em;
  color: #fff;
  text-align: center;
  width: 70%;
  border-bottom: 1px solid #555;
  z-index: 10;
  background-color: #191919;
}
.menuButton .select{
  border-bottom: 2px solid;
  color: #E32119;
}
.menuButton span{
  font-size: 0.8em;
  font-weight: 700;
  padding: 0.3em 0;
}
.menuBody{
  padding: 3em 1em 0 1em;
  z-index: 9;
}
.menuRect .title1{
    color: #E32119;
    border-top: 1px solid #333;
}
.menuRect .title1 span{
    font-size: 1em;
    font-weight: 700;
}
.menuRect .title2{
    color:#fff;
    padding-left: 0.8em;
    font-size: 0.9em;
}
.menuRect .title3{
    color:#fff;
    padding-left: 1.6em;
    font-size: 0.9em;
}
.menuRect .title2read{
    color:#AAA;
    padding-left: 0.8em;
    font-size: 0.9em;
}
.menuRect .title3read{
    color:#AAA;
    padding-left: 1.6em;
    font-size: 0.9em;
}
.menuMore{
  text-align: center;
    height: 3em;
    bottom: 3em;
    line-height: 3em;
    color: #Fff;
    background-color: #000;
    opacity: 0.85;
}
.menuMore span i{
  margin-right: 0.5em;
}
.menuMore span{
  font-size: 0.9em;
}
.noteMore{
    text-align: center;
    bottom: 3em;
    background-color: #191919;
}
.noteMore button {
  width: 92%;
}
.noteMore .NoteBody{
  width: 92%;
   resize: none;
   margin-top:0.8em;
   background-color: #191919;
   color: #fff;
   border: none;
}
.noteMore .NoteBody::-webkit-input-placeholder{
    color:#AAA;
}
.noteMore .NoteBody::-moz-placeholder{   /* Mozilla Firefox 19+ */
    color:#AAA;
}
.noteMore .NoteBody:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
    color:#AAA;
}
.noteMore .NoteBody:-ms-input-placeholder{  /* Internet Explorer 10-11 */
    color:#AAA;
}

.aboutMore{
    text-align: center;
    bottom: 3em;
    color: #Fff;
    background-color: #191919;
}
.aboutMore .title{
    bottom: 3em;
    line-height: 3em;
    font-weight: 700;
    font-size: 0.9em;
}
.aboutMore img{
  width: calc(100% - 2em);
}
.aboutMore .body{
  text-align: left;
  font-size: 0.8em;
  padding: 0.5em 1em;
}
</style>
